
  import {Component, Vue} from "vue-property-decorator";
  import {findDriverResource} from "@/modules/FindDriver/resources/find-driver.resource";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {IFindDriver} from "@/modules/FindDriver/interfaces/find-driver.interface";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
  import {IApp} from "@/interfaces/app.interface"
  import ActionsCell from "@/modules/FindDriver/components/ActionsCell.vue";

  @Component({
    components: {
      ActionsCell,
      SimpleAppTable,
    },
  })
  export default class FindDriverIntro extends Vue {
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    $refs: any;
    loading = false;
    tableList: IFindDriver.ITableEntity[] = [];
    invalidText = '';
    hasRequest = false;
    displayMobileOverlay = false;
    formModel = {
      carNumber: "",
    };
    customComponents = {
      ActionsCell,
    };

    get dataProps(): IAppTable.ITableProp[] {
      return [
        { label: 'ФИО',    prop: 'persName',   propType: IApp.SortingPropType.String, },
        { label: 'Телефон',         prop: 'phone',  propType: IApp.SortingPropType.String, },
        {
          label: 'Действия',
          prop: 'id',
          noSorting: true,
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'ActionsCell',
        },
      ];
    }

    async getInfo() {
      this.loading = true;
      let requestData: IFindDriver.ITableEntity[] = await findDriverResource.getInfoByNumber(this.formModel.carNumber);
      this.tableList = requestData
        ? requestData.map((item: IFindDriver.ITableEntity) => {
          return {
            ...item,
            rowClass: item.mainPhoneFlag ? 'main-phone' : '',
          }
        })
        : [];
      this.hasRequest = true;
      this.loading = false;
    }

    async checkNumber(value) {
      if (value && value.length >= 7 && value.length <= 9) {
        this.invalidText = '';
        await this.getInfo();
      }
      else if (value && value.length < 7) {
        this.invalidText = 'Номер должен состоять минимум из 7 символов, включая код региона';
        this.hasRequest = false;
      }
      else {
        this.invalidText = '';
        this.hasRequest = false;
      }
    }

    async clearNumber() {
      this.formModel.carNumber = '';
      this.hasRequest = false;
      this.tableList = [];
      await this.$nextTick();
      this.$refs.numberInput.focus();
    }

    async inputFocus() {
      const inputElement = this.$refs.numberInput.$el.querySelector('input');
      const contentBlock = document.querySelector('.app-page__content');

      this.displayMobileOverlay = true;
      await this.$nextTick();

      if (inputElement && contentBlock) {
        const inputRect = inputElement.getBoundingClientRect();
        const contentRect = contentBlock.getBoundingClientRect();
        const scrollTop = inputRect.top - contentRect.top + contentBlock.scrollTop - 20;

        setTimeout(() => {
          contentBlock.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }, 500);
      }
    }
  }
